import { FC } from "react";

import { Avatar, Button, Typography } from "../../designComponents";
import { InfoRowStyled, VerticalSpaceStyled } from "../../style/reusableStyle";
import { BrowsedJobDetailsContainerStyled } from "../TechnicianBrowsedJobDetails/style";

interface UserProfilePropsType {
  name?: string;
  email?: string;
  imgUrl?: string;
  status?: string;
  position?: string;
  loading?: boolean;
  showConfirm?: boolean;
  setShowConfirm?: (boolean: boolean) => void;
  handleApprove?: () => void;
}

const UserProfile: FC<UserProfilePropsType> = ({
  name,
  email,
  imgUrl,
  status,
  loading,
  handleApprove,
  showConfirm,
  setShowConfirm,
}) => {
  return (
    <BrowsedJobDetailsContainerStyled>
      <Typography
        variant="normal"
        fontColor="secondary"
        className="userProfile"
        strong
      >
        USER PROFILE
      </Typography>

      <VerticalSpaceStyled>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "10px",
            marginTop: "20px",
          }}
        >
          {/* User Image */}
          <InfoRowStyled className="userImage">
            <Avatar size="xl" src={imgUrl || ""} />
          </InfoRowStyled>

          {/* Name */}
          <InfoRowStyled>
            <Typography fontColor="dark">{name || "Nitish Rajak"}</Typography>
          </InfoRowStyled>

          <InfoRowStyled>
            <Typography fontColor="disable">
              {email || "nitish.technician@gmail.com"}
            </Typography>
          </InfoRowStyled>

          {setShowConfirm && status === "PENDING_APPROVAL" && (
            <InfoRowStyled>
              <Button onClick={() => setShowConfirm(true)}>Approve</Button>
            </InfoRowStyled>
          )}

          {status === "APPROVED" && (
            <InfoRowStyled
              style={{ display: "flex", alignItems: "center", gap: 8 }}
            >
              <Typography fontColor="light">Approved</Typography>

              <span
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: 20,
                  height: 20,
                  borderRadius: "50%",
                  backgroundColor: "#22c55e", // green
                  color: "#fff",
                  fontSize: 12,
                  fontWeight: 700,
                }}
              >
                ✓
              </span>
            </InfoRowStyled>
          )}
        </div>
      </VerticalSpaceStyled>

      {showConfirm && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            backgroundColor: "rgba(0,0,0,0.4)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1000,
          }}
        >
          <div
            style={{
              background: "#fff",
              padding: 24,
              borderRadius: 8,
              width: 320,
              textAlign: "center",
            }}
          >
            <Typography strong>Are you sure?</Typography>

            <Typography fontColor="disable" style={{ margin: "12px 0 20px" }}>
              Do you want to approve this user?
            </Typography>

            <div
              style={{
                display: "flex",
                gap: 12,
                justifyContent: "center",
              }}
            >
              {setShowConfirm && (
                <Button
                  variant="gray"
                  onClick={() => setShowConfirm(false)}
                  isDisabled={loading}
                >
                  Cancel
                </Button>
              )}
              <Button onClick={handleApprove} isLoading={loading}>
                Yes, Approve
              </Button>
            </div>
          </div>
        </div>
      )}
    </BrowsedJobDetailsContainerStyled>
  );
};

export default UserProfile;
